import React from 'react'
import { useMessageFeedContext } from '../../chat-widget/MessageFeedContext'
import { Block, LiveMessageBlock } from '../../chat-data/types'
import { ReplyButtonsBlock } from './reply-buttons-block/ReplyButtonsBlock'
import { MessageBlock } from './message-block/MessageBlock'
import { FillFormBlock } from './fill-form-block/FillFormBlock'
import { SuggestedTimes } from './book-meeting-block/SuggestedTimes'
import { BookMeetingBlock } from './book-meeting-block/BookMeetingBlock'

interface Props {
  block: Block
  isOwnMessage: boolean
  onLiveMessageVisible: (event: LiveMessageBlock) => void
}

export const BlockRender = ({ block, isOwnMessage, onLiveMessageVisible }: Props) => {
  const { pickReplyButton } = useMessageFeedContext()

  switch (block.type) {
    case 'Message':
    case 'PiperAiMessage':
      return <MessageBlock block={block} isOwnMessage={isOwnMessage} />
    case 'LiveMessage':
      return (
        <MessageBlock
          block={block}
          isOwnMessage={isOwnMessage}
          onMessageVisible={onLiveMessageVisible}
        />
      )
    case 'MessageToPiperAi':
      return (
        <MessageBlock
          block={{
            ...block,
            parts: [{ type: 'Text', text: block.value.content }],
            type: 'LiveMessage',
          }}
          isOwnMessage={isOwnMessage}
        />
      )
    case 'ReplyButtons':
      return <ReplyButtonsBlock block={block} onReplyButtonClick={pickReplyButton} />
    case 'FillForm':
      return <FillFormBlock block={block} />
    case 'BookMeeting':
      return <BookMeetingBlock block={block} />
    case 'SuggestedTimes':
      return <SuggestedTimes block={block} />
    default:
      return <>Unimplemented block</>
  }
}
